export default __webpack_public_path__ + "static/scalpelblade-aa92645592118f3421d4c170634c0fd1.png";